import React, { useRef } from "react";
import * as THREE from "three";
import { useGLTF, useTexture } from "@react-three/drei";

// import { motion } from "framer-motion-3d";
import { motion } from "framer-motion";

function Chair({
  currentCrocoColor,
  onCrocoTexture,

  onMatFabric,
  onGlossyTexture,
  currentColor,
}) {
  const ref = useRef();
  const { nodes, materials } = useGLTF(
    "/chairItems/model/barcelonaChair_12_newrotouc.gltf"
  );

  const propsTexturesCroco = useTexture({
    map: "./chairItems/textures-croco/smalldetail-croco__Color.jpg",
    displacementMap:
      "./chairItems/textures-fabric-green/fabric-green_displacement.jpg",
  });

  const propsTexturesFabric = useTexture({
    map: "./chairItems/textures-fabric-green/fabric-green_Color.jpg",
    displacementMap:
      "./chairItems/textures-fabric-green/fabric-green_displacement.jpg",
    roughness: "./chairItems/textures-fabric-green/fabric-green_roughness.jpg",
  });

  return (
    <group ref={ref} dispose={null}>
      <motion.group>
        {/*   metal */}
        {onMatFabric && (
          <>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionTop.geometry}
              material={materials.cushionTop}
            >
              <meshPhongMaterial
                {...propsTexturesFabric}
                displacementScale={0}
                shininess={8}
                color={currentColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionBottom.geometry}
              material={materials.cushionBottom}
            >
              <meshPhongMaterial
                {...propsTexturesFabric}
                displacementScale={0}
                shininess={8}
                color={currentColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
          </>
        )}
        {/* transp */}
        {onGlossyTexture && (
          <>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionTop.geometry}
              material={materials.cushionTop}
            >
              <meshPhysicalMaterial
                {...propsTexturesFabric}
                displacementScale={0}
                shininess={50}
                color={currentColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionBottom.geometry}
              material={materials.cushionBottom}
            >
              <meshPhysicalMaterial
                {...propsTexturesFabric}
                displacementScale={0}
                shininess={50}
                color={currentColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
          </>
        )}

        {onCrocoTexture && (
          <>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionTop.geometry}
              material={materials.cushionTop}
            >
              <meshPhongMaterial
                {...propsTexturesCroco}
                displacementScale={0}
                shininess={100}
                color={currentCrocoColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
            <mesh
              receiveShadow
              castShadow
              geometry={nodes.cushionBottom.geometry}
              material={materials.cushionBottom}
            >
              <meshPhongMaterial
                {...propsTexturesCroco}
                displacementScale={0}
                shininess={100}
                color={currentCrocoColor}
                normalScale={500}
                normalRepeat={1}
                side={THREE.DoubleSide}
              />
            </mesh>
          </>
        )}
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.cushionTop.geometry}
          material={materials.cushionTop}
        >
          <meshPhongMaterial
            {...propsTexturesFabric}
            displacementScale={0}
            shininess={50}
            color="#ffffff"
            normalScale={500}
            normalRepeat={1}
            side={THREE.DoubleSide}
          />
        </mesh>
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.cushionBottom.geometry}
          material={materials.cushionBottom}
        >
          <meshPhongMaterial
            {...propsTexturesFabric}
            displacementScale={0}
            shininess={8}
            color="#ffffff"
            normalScale={500}
            normalRepeat={1}
            side={THREE.DoubleSide}
          />
        </mesh>

        <mesh
          receiveShadow
          castShadow
          geometry={nodes.dosRuck.geometry}
          material={materials.dosRuck}
        >
          <meshPhysicalMaterial
            color="#ffffff"
            roughness={0}
            metalness={1}
            side={THREE.DoubleSide}
          />
        </mesh>

        <mesh
          receiveShadow
          castShadow
          geometry={nodes.rubberTop.geometry}
          material={materials.rubberTop}
        >
          <meshPhysicalMaterial
            color="#000000"
            roughness={0}
            metalness={1}
            side={THREE.DoubleSide}
          />
        </mesh>

        <mesh
          receiveShadow
          castShadow
          geometry={nodes.rubberBottom.geometry}
          material={materials.rubberBottom}
        >
          <meshPhysicalMaterial
            color="#000000"
            roughness={0}
            metalness={1}
            side={THREE.DoubleSide}
          />
        </mesh>
      </motion.group>
    </group>
  );
}

export default Chair;
